var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7889519D-EF54-406E-B1D9-A6025623E498") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-40.000000, -1066.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flight-details",
    transform: "translate(40.000000, 1065.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24682241,12.9806646 L1.25191919,15.976047 L0,14.4785389 L1.49736624,11.4836701 L0.00013778098,8.48887024 L1.25212586,6.99130448 L4.24689129,9.9860699 L8.89319026,9.98596302 L7.24193231,1.00006042 L9.86863124,1 L13.8416832,9.98560958 L17.8823974,9.98551663 C19.0468821,9.98548984 20.0000189,10.6592398 20,11.4830049 C19.9999811,12.30677 19.0472924,12.9805638 17.8823285,12.9805906 L13.8411351,12.9806835 L9.86814898,21.9655175 L7.24145005,21.9655779 L8.89312139,12.9805577 L4.24682241,12.9806646 Z",
    id: "Shape-Copy",
    fill: "#262728"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDetails);
export default __webpack_public_path__ + "static/media/flight_details.bcd279fe129ca337dca94447489c0b1f.svg";
export { ForwardRef as ReactComponent };